import type { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";

type Report = Dtos.Admin.SuretyAccount.Get.Response["companies"][number]["creditReports"][number];

const exclusionMessageByScore = {
	997: "Collections score was not calculated because a collection balance was not submitted.",
	998: "Recent bankruptcy on file.",
	999: "Experian does not have enough information to generate a score.",
} as const;

const isExclusionScore = (score: unknown): score is keyof typeof exclusionMessageByScore =>
	score === 997 || score === 998 || score === 999;

export const experianFsrExclusionMessage = (report: Report | undefined): string | undefined => {
	const profile = report?.creditProfile;
	if (Option.isNone(profile) || profile.vendor !== "experian") return undefined;
	if (Option.isSome(profile.experianFsr)) return undefined;

	const score = profile.profile?.scoreInformation?.fsrScore?.score;
	if (!isExclusionScore(score)) return undefined;
	return exclusionMessageByScore[score];
};
